import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  ArrowForwardIosRounded as ArrowForwardIosRoundedIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getProfileMenuItems } from "./ProfileMenuItems";

const COLORS = {
  cream: "#F7F4EF",
  white: "#FFFFFF",
  black: "#171717",
  mutedBlack: "#3A3A3A",
  grey: "#77736D",
  border: "#DDD7CE",
  goldLight: "#C4A36A",
};

const SidebarItem = ({ icon, label, active, onClick }) => (
  <ListItem
    component="button"
    onClick={onClick}
    sx={{
      width: "100%",
      border: 0,
      outline: "none",
      textAlign: "left",
      background: active ? COLORS.black : "transparent",
      color: active ? COLORS.white : COLORS.mutedBlack,
      borderRadius: 0,
      px: 2,
      py: 1.6,
      mb: 0.6,
      cursor: "pointer",
      transition: "all 0.25s ease",
      "&:hover": {
        background: active ? COLORS.black : COLORS.cream,
        color: active ? COLORS.white : COLORS.black,
        transform: "translateX(3px)",
      },
      "& .MuiListItemIcon-root": {
        minWidth: 40,
        color: active ? COLORS.goldLight : COLORS.grey,
        transition: "color 0.25s ease",
      },
    }}
  >
    <ListItemIcon>{icon}</ListItemIcon>

    <ListItemText
      primary={label}
      primaryTypographyProps={{
        fontSize: 13,
        fontWeight: active ? 600 : 500,
        letterSpacing: "0.02em",
      }}
    />

    <ArrowForwardIosRoundedIcon
      sx={{
        fontSize: 12,
        opacity: active ? 0.9 : 0,
        transform: active
          ? "translateX(0)"
          : "translateX(-5px)",
        transition: "all 0.25s ease",
      }}
    />
  </ListItem>
);

export default function ProfileSideBar({ active }) {
  const navigate = useNavigate();

  const items = getProfileMenuItems({
    navigate,
  });

  return (
    <Box
      sx={{
        display: {
          xs: "none",
          sm: "none",
          md: "block",
        },
      }}
    >
      <Box
        sx={{
          border: `1px solid ${COLORS.border}`,
          backgroundColor: COLORS.white,
          borderRadius: 0,
          overflow: "hidden",
          position: "sticky",
          top: 100,
        }}
      >
        <Box
          sx={{
            backgroundColor: COLORS.black,
            color: COLORS.white,
            p: 2.5,
          }}
        >
          <Box
            sx={{
              fontSize: 10,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: COLORS.goldLight,
              mb: 0.7,
            }}
          >
            Account
          </Box>

          <Box
            sx={{
              fontFamily: "Georgia, serif",
              fontSize: 24,
            }}
          >
            My Wardrobe
          </Box>
        </Box>

        <List sx={{ p: 1.2 }}>
          {items.map((item) => (
            <SidebarItem
              key={item.key}
              icon={item.icon}
              label={item.label}
              active={active === item.key}
              onClick={item.onClick}
            />
          ))}
        </List>
      </Box>
    </Box>
  );
}